export class TopalValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TopalValidationError';
  }
}
